// extracted by mini-css-extract-plugin
export default {"disable_select":"projectsDropDownItem_disable_select__KXpCQ","itemOverlay":"projectsDropDownItem_itemOverlay__gS-mk","searchItem":"projectsDropDownItem_searchItem__CxPVP"};